import { NATIONAL_ID_TRANSLATIONS } from '../../constants/nationalId'
import type { NationalIdCountries } from '../../types/nationalId'

export function getNationalIdTranslation(country: NationalIdCountries) {
  return NATIONAL_ID_TRANSLATIONS[country]
}
